import React from 'react'
import './index.less'

/**
 * @param {boolean} color 颜色值 
 * @param {number} time 显示时间 
 * @Author: KK
 * @Date: 2022-12-29
 * @LastEditors: KK
 * @LastEditTime: 2022-12-29
 * @desc: 传入颜色值，例如 rgb、#fff
 */

export default class extends React.Component {
  state = {
    toastStatus: false,
    flag: false
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }


  hideRule = async (status) => {
    if (this.state.flag) {
      return
    }
    this.setState({
      flag: true
    })

    let time = this.props.time || 3000
    let id = this.props.id


    if (this.state.toastStatus == true) {
      return
    }

    this.setState({
      toastStatus: status
    })

    document.getElementById(`toast${id}`).setAttribute("class", "toastblack block toastHide")

    if (status == true) {
      setTimeout(() => {
        this.setState({
          toastStatus: false,
          flag: false
        })
        document.getElementById(`toast${id}`).setAttribute("class", "toast hide")
      }, time)
      return 1
    }
  }

  render() {
    let { language, lang, toastContent, id, color, time } = this.props
    return (
      <div style={{ animationDuration: `${(time / 1000) + 1}s` }} id={`toast${id}`} className={`toastblack hide`} onClick={this.hideRule.bind(this, false)}>
        <span className={`toastContent`} style={{ backgroundColor: `${color}` }}>
          {toastContent}
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/component/ToastColor/index.js